import React from "react";
import CommonCard from "../CommonCard";

const ImageCard = ({ value }) => {
  return <CommonCard field={null} value={value} image={true} />;
};

export default ImageCard;
